import { Link } from 'react-router-dom';

function PrivacyPolicyPage() {
    return (
        <div className="min-h-screen bg-white relative">
            <header className="fixed top-0 w-full z-50 bg-white shadow-md py-4 px-6 md:px-12 flex justify-between items-center">
                <Link to="/">
                    <img src="../image/Chaln_black.png" alt="Logo" className="h-12 cursor-pointer" />
                </Link>
                <nav className="hidden md:flex space-x-6 text-sm font-bold text-blue-600">
                    <a href="#privacy-policy" className="hover:text-blue-400 transition">個人情報保護方針</a>
                    <a href="#pi-handling" className="hover:text-blue-400 transition">個人情報取扱い</a>
                    <a href="#inq-handling" className="hover:text-blue-400 transition">お問い合わせ個人情報</a>
                </nav>
            </header>



            <main className="px-6 md:px-20 pt-20 pb-20">
                <div className="max-w-6xl mx-auto">
                    {/* プライバシーポリシータイトル */}
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 my-32">
                        プライバシーポリシー
                    </h1>
                    
                    {/* 目次 */}
                    <div className="mb-16 p-6 md:p-8 rounded-lg" id="toc">
                        <h2 className="text-2xl md:text-3xl font-bold mb-6">目次</h2>
                        <p className="text-base md:text-lg leading-relaxed">
                            <a href="#privacy-policy" className="text-blue-600 hover:text-blue-800 underline transition">1. 個人情報保護方針（第2版）</a><br />
                            <a href="#pi-handling" className="text-blue-600 hover:text-blue-800 underline transition">2. 個人情報の取扱いについて（第1版）</a><br />
                            <a href="#inq-handling" className="text-blue-600 hover:text-blue-800 underline transition">3. お問い合わせにおける個人情報の取扱いについて</a>
                        </p>
                    </div>

                    {/* 1) 個人情報保護方針（第2版） */}
                    <div className="mb-16 p-6 md:p-8  rounded-lg scroll-mt-24" id="privacy-policy">
                        <h2 className="text-2xl md:text-3xl font-bold mb-8">個人情報保護方針（第2版）</h2>

                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            株式会社シャルンは、セールスプロモーション事業、通信業界事業を実施する上で、お客様の個人情報がプライバシーを構成する重要な情報であることを深く認識し、業務において個人情報を取り扱う場合には、個人情報に関する法令及び個人情報保護のために定めた社内規定を定め、また、組織体制を整備し、個人情報の適切な保護に努めることにより、お客様を尊重し、当社に対する期待と信頼に応えていきます。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（1）個人情報の取得、利用、提供</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社は、事業活動の範囲内で個人情報の利用目的を特定し、その目的達成のために必要な限度で公正かつ適正に個人情報の取得、利用及び提供を行います。また、取得した個人情報の目的外利用をしないよう処置を講じます。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（2）法令・規範の遵守</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社は、個人情報に関する法令、国が定める指針、その他の規範及び社会秩序を遵守し、個人情報の適切な保護に努めます。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（3）個人情報の適切な管理</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社は、私たちが取り扱う個人情報について、不正アクセス、紛失、破壊、改ざん、漏えいなどの危険を十分に認識し、合理的な安全対策を実施するとともに、問題が発生した場合は適切な是正措置を講じます。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（4）問い合わせへの対応</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社は、私たちが取り扱う個人情報について、本人から開示、訂正、利用停止及び苦情相談等のお問い合わせがあった場合は適正に対応します。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（5）継続的改善</p>
                        <p className="text-base md:text-lg text-gray-700 mb-8">
                            当社は、個人情報保護に関する管理規定及び管理体制を整備し、全社員で徹底して運用するとともに定期的な見直しを行い、個人情報保護マネジメントシステムの継続的な改善に努めます。
                        </p>

                        <p className="text-base md:text-lg text-gray-700">
                            2025 年 2 月 7 日　制定<br />
                            2025 年 6 月 23 日　改定<br /><br />
                            株式会社シャルン<br />
                            代表者　我妻 武郎<br /><br />
                            ＜個人情報保護方針に関する連絡先＞ 個人情報問合せ窓口<br />
                            住所　東京都新宿区新宿 2 丁目 12-13 2F<br />
                            個人情報保護管理者　我妻 武郎<br />
                            連絡先　03-5050-4341、info@chaln.co.jp
                        </p>
                    </div>

                    {/* 2) 個人情報の取扱いについて（第1版） */}
                    <div className="mb-16 p-6 md:p-8  rounded-lg scroll-mt-24" id="pi-handling">
                        <h2 className="text-2xl md:text-3xl font-bold mb-8">個人情報の取扱いについて（第1版）</h2>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">当社が取扱う個人情報について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社では「個人情報保護方針」に基づき個人情報の適切な保護に取り組んでいます。当社が事業の用に供するために取得し、または保有する個人情報について、以下の通りお知らせいたします。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（１）個人情報の取扱事業者の名称及び住所並びに法人にあたってはその代表者の氏名</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            事業者名：株式会社シャルン<br />
                            代表取締役：我妻 武郎<br />
                            住所：東京都新宿区新宿 2 丁目 12-13 2F
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（２）個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            個人情報保護管理者：我妻 武郎<br />
                            連絡先：03-5050-4341
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（３）個人情報の利用目的</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社が事業活動において取扱う個人情報の利用目的は、次の通りといたします。<br />
                            ①保有個人データ<br />
                            ・取引先情報：業務管理、各種連絡、請求、支払い管理のため<br />
                            ・従業者情報：従業者管理に係わる業務に利用するため（業務・労務・人事管理業務、給与関連業務、福利厚生業務など）<br />
                            ・採用応募者情報：採用に係わる業務に利用するため（採用に関する情報提供、採用可否判断、採用業務に関する連絡など）<br />
                            ・退職者情報：退職者との連絡、退職者からのお問合せへの対応に利用するため<br />
                            ・お問合せ者情報：お問合せに回答するため<br />
                            ・本人および代理人の情報（開示等請求時）：開示等の求めに回答するため<br />
                            ・登録スタッフ情報：スタッフの雇用管理・労務管理・勤怠管理・福利厚生・災害等の緊急事態が発生した際の連絡・給与関連業務・研修の受講管理等に使用するため<br />
                            ・会員情報：会員登録、会員管理業務で利用するため、契約及びそれに伴う連絡、商品配送、アフターケアなどに利用するため、顧客情報管理、販売管理、購入時・利用時及び失効時のポイント履歴の確認などに利用するため<br />
                            ・購入者情報：契約及びそれに伴う連絡、商品配送、アフターケアなどに利用するため、顧客情報管理、販売管理に利用するため<br />
                            ②それ以外取得個人情報<br />
                            ・受託した業務により取得した個人情報：契約及びそれに伴う連絡、受託業務の遂行、アフターケアなどに利用するため<br />
                            ・求人サイトから取得した情報：求人者に対する採用の可否を判断・通知するため<br />
                            ・協力会社スタッフ情報：委託元の業務遂行及び、それに関連する業務のため、顧客に情報を提出するため
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（４）個人情報に関するお問合せ窓口</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            保有個人データに関わるものを含め、個人情報の取扱についての苦情・相談、問合せは、下記の【問合せ窓口】までお申し出ください。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（５）所属する認定個人情報保護団体の名称および苦情の解決の申し出先</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">なし</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（６）開示等の手続について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            当社では、保有個人データに関して、ご本人の開示等（利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去、第三者への提供の停止および第三者提供記録の開示）の請求に迅速に対応いたします。ご希望される場合には、お申し出いただいた方がご本人或いはその代理人であることを確認した上で、合理的な期間及び範囲で対応いたします。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（７）開示等の受付方法・窓口</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            保有個人データに関する開示等のお申し出は、下記の受付窓口までご連絡ください。ご連絡いただきましたら、当社所定の「保有個人データ開示等請求書」を郵送または、FAX、メール等でお送りします。内容ご記入の上必要書類を同封し、郵送またはメール等にてお申し込み下さい（送付料は請求者のご負担となります）。<br />
                            ご本人（または代理人）であることを確認した上で、ご希望の開示方法により回答いたします。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（８）個人情報の安全管理のために講じた措置について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-8">
                            当社では、個人情報を厳正に取り扱うため、JIS Q 15001 に準拠した個人情報保護方針を基に、個人情報に関する規程等を策定し、個人情報保護マネジメントシステムを運用しております。<br />
                            個人情報の適正な取扱いの確保のため、組織的・人的・物理的・技術的の 4 つの観点より安全管理措置を講じております。<br />
                            当社は外国にある第三者に委託を行っておりますが、外的環境の把握等適切に安全管理措置を講じております。（※該当しない場合は削除）<br />
                            具体的な安全管理措置については下記【問合せ窓口】よりお問い合わせください。
                        </p>

                        <p className="text-base md:text-lg text-gray-600 mb-6">2025年 6月 23日制定</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">【問合せ窓口】</p>
                        <p className="text-base md:text-lg text-gray-700">
                            窓口の名称：個人情報問合せ窓口／窓口責任者：村山陸<br />
                            住所：東京都新宿区新宿 2 丁目 12-13 2F<br />
                            連絡先：03-5050-4341、info@chaln.co.jp
                        </p>
                    </div>

                    {/* 3) お問い合わせにおける個人情報の取扱いについて */}
                    <div className="mb-16 p-6 md:p-8  rounded-lg scroll-mt-24" id="inq-handling">
                        <h2 className="text-2xl md:text-3xl font-bold mb-8">お問い合わせにおける個人情報の取扱いについて</h2>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（１）組織の名称又は氏名</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">株式会社シャルン</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（２）個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            個人情報保護管理者：我妻 武郎<br />
                            電子メール：info@chaln.co.jp<br />
                            電話番号：03-5050-4341
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（３）個人情報の利用目的</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">お問い合わせいただいた内容に回答するため</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（４）個人情報の第三者提供について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">取得した個人情報は法令等による場合を除いて第三者に提供することはありません。</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（５）個人情報の取扱いの委託について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            取得した個人情報の取扱いの全部又は、一部を委託することがあります。<br />
                            その場合には、当社において最善の考慮を行います。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（６) 個人情報を与えなかった場合に生じる結果</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            個人情報を与えることは任意です。個人情報に関する情報の一部をご提供いただけない場合は、
                            お問い合わせ内容に回答できない可能性があります。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（７）保有個人データの開示等および問い合わせ窓口について</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">
                            ご本人からの求めにより、当社が保有する保有個人データに関する開示、利用目的の通知、
                            内容の訂正・追加または削除、利用停止、消去、第三者提供の停止および第三者提供記録の開示（以下、開示等という）に応じます。<br />
                            開示等に応ずる窓口は、下記「当社の個人情報の取扱いに関する苦情、相談等の問合せ先」を参照してください。
                        </p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（８）本人が容易に認識できない方法による個人情報の取得</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">クッキーやウェブビーコン等を用いるなどして、本人が容易に認識できない方法による個人情報の取得を行っておりません。</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（９）個人情報保護方針</p>
                        <p className="text-base md:text-lg text-gray-700 mb-6">当社ホームページの個人情報保護方針をご覧下さい。</p>

                        <p className="text-lg md:text-xl font-semibold text-gray-800 mb-3">（10）当社の個人情報の取扱いに関する苦情、相談等の問合せ先</p>
                        <p className="text-base md:text-lg text-gray-700">
                            窓口の名称：個人情報問合せ窓口<br />
                            連絡先：お問い合わせ窓口担当：村山陸<br />
                            住所：東京都新宿区新宿2丁目12-13 2F<br />
                            電話：03-5050-4341<br />
                            電子メール：info@chaln.co.jp
                        </p>
                    </div>

                    {/* ホームに戻るボタン */}
                    <div className="text-center py-16">
                        <Link
                            to="/"
                            className="inline-block py-4 px-12 rounded-full bg-blue-600 text-white font-bold text-lg shadow-lg hover:scale-105 transition"
                        >
                            戻る
                        </Link>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default PrivacyPolicyPage;